
export enum SidebarTab {
  PUBLIST = 'publist',
  RESEARCH_DATA_LIST = 'research_data_list',
}